import { createFileRoute } from "@tanstack/react-router";
import { BudgetPage } from "@/features/budget/budget-page";

export const Route = createFileRoute("/app/w/$weddingId/budget")({ component: BudgetPage });
